import { createAsyncThunk } from "@reduxjs/toolkit";
import magnifiAPI from "services/api/magnifi";

export const getCoreFields = createAsyncThunk("fields/getCoreFields", async (payload) => {
  try {
    const response = await magnifiAPI.getCoreFields(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const addCoreField = createAsyncThunk("fields/addCoreField", async (payload) => {
  try {
    const response = await magnifiAPI.addCoreField(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const updateCoreField = createAsyncThunk("fields/updateCoreField", async (payload) => {
  try {
    const response = await magnifiAPI.updateCoreField(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getOrganizationCustomFields = createAsyncThunk(
  "fields/getOrganizationCustomFields",
  async ({ entityId, payload }) => {
    try {
      const response = await magnifiAPI.getOrganizationCustomFields({ entityId, payload });

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);
